import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { ErrorFallback } from '@/components/error-fallback';

// Exported for use in unit test wrappers
export function MediaUnitRouteError({ error, reset }: ErrorComponentProps) {
  return <ErrorFallback error={error} reset={reset} />;
}

// Layout route for /media-units/$id and child routes (for example /edit).
// The detail page itself lives in $id/index.tsx.
export const Route = createFileRoute('/media-units/$id')({
  component: () => <Outlet />,
  errorComponent: MediaUnitRouteError,
});

export { MediaUnitDetailPage } from './$id/index';
